import { StyledProps } from 'styled-components'
import styled from 'styled-components/native'

import { PressableBehavior } from './types'

export type StyledPressableContainerProps = StyledProps<{
  pressed?: boolean
  behavior?: PressableBehavior
}>

const getPressedStyleWithBehavior = (behavior: PressableBehavior) => {
  switch (behavior) {
    case 'opacity':
      return 'opacity: 0.8;'
    default:
      return ''
  }
}

export const StyledPressableContent = styled.View<StyledPressableContainerProps>`
  display: flex;
  ${({ pressed, behavior }) => (pressed ? getPressedStyleWithBehavior(behavior) : '')}
`
